// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3i1Ia","errorLogs":"EditorFooter_errorLogs__1Hx6W"};